<template>
    <ModalFormCard :action="options.action" :submittedCallback="submittedCallback" class="modal-default">
        <template #title>{{ options.head ? options.head : '&nbsp;' }}</template>

        <template #default="{ saving, errors }">
            <input :value="options.method || 'POST'" name="_method" type="hidden" />

            <input v-for="i in options.inputs" :name="i.name" :value="i.value" type="hidden" />

            <p class="text-15" :class="[options.messageClass]" v-html="options.message" />

            <div class="grid grid-cols-4 pt-7 gap-4" v-if="options.button !== false">
                <ButtonSaving class="button-black h-12 col-span-2" :disabled="saving" v-if="submit">
                    {{ options.button }}
                </ButtonSaving>

                <button class="button-black h-12 col-span-2" :disabled="saving" type="button" v-else @click="send">
                    {{ options.button }}
                </button>

                <ButtonSaving class="button-purple h-12" type="button" :disabled="saving" @click="$emit('close')"> Cancel </ButtonSaving>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
import Modal from '~/mixins/modal.js'

export default {
    mixins: [Modal],

    methods: {
        send() {
            this.options.submitFunction()
            this.$event.$emit('modal-form-completed')
            this.$event.$emit('modal-close')
        },

        submittedCallback(res) {
            // console.log('submittedCallback')
            if (this.options.submittedCallback) {
                this.options.submittedCallback(res)
            }
            this.$event.$emit('modal-form-completed')
            this.$event.$emit('modal-close')
        },
    },

    computed: {
        submit() {
            return this.options.submitFunction != null ? false : true
        },
    },
}
</script>
